<template>
    <div class="page">
      <el-form size="small" label-width="100px" class="margin15-tb">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="最高减免：">
              <el-input style="width:30%" v-model="cas.planDiscount" @keyup.native="numberDisCount" controls-position="right" placeholder="最大为100"></el-input>&nbsp; %
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="作业设置：">
              <el-radio v-model="cas.planType" label="msg">短信</el-radio>
              <el-radio v-model="cas.planType" label="v&m">短信加语音</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="作业对象：">
              <el-select v-model="cas.relationShip" placeholder="请选择" style="width: 100%;" filterable>
                <el-option
                  v-for="item in replayObjectOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="作业天数：">
              <el-input style="width:30%" v-model="days" controls-position="right" placeholder="最大为30天" @keyup.native="numberDays"></el-input>&nbsp; 天，至
              <el-input v-model="cas.planStartTime" style="width: 150px;" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" style="margin-left: 25px">
        <el-button type="primary" size="small" @click="saveCollectionSet" plain>保存</el-button>
      </div>
    </div>
</template>
<script>

export default {
  data() {
    return {
      days: '3',
      cas: {
        planType: 'msg',
        planDiscount: '50',
        relationShip: 'benrendianhua',
        planDays: '',
        planStartTime: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate() + 1}`
      },
      replayObjectOption: [
        {
          value: 'benrendianhua',
          label: '本人电话'
        },
        {
          value: 'zhixidianhua',
          label: '直系电话'
        },
        {
          value: 'feizhixidianhua',
          label: '非直系电话'
        }
      ]
    };
  },
  mounted() {
    this.numberDays();
    this.getSimulateInfo();
  },
  methods: {
    // 校验作业天数输入框
    numberDays() {
      this.days = this.days.replace(/[^\\.\d]/g, '');
      this.days = this.days.replace('.', '');
      if (this.days > 30) {
        this.days = 30;
      }
      if (this.days <= 0 && this.days !== '') {
        this.days = 1;
      }
      // 计算作业天数
      if (this.days === null || this.days === '' || this.days === undefined) {
        this.cas.planStartTime = '';
        return;
      }
      const days = this.days;
      const nowDate = new Date();
      nowDate.setTime(nowDate.getTime() + ((days) * 24 * 60 * 60 * 1000));
      const newDate = `${nowDate.getFullYear()}-${nowDate.getMonth() + 1}-${nowDate.getDate()}`;
      this.cas.planStartTime = newDate;
      this.cas.planDays = days;
    },
    // 校验最高减免输入框
    numberDisCount() {
      this.cas.planDiscount = this.cas.planDiscount.replace(/[^\\.\d]/g, '');
      this.cas.planDiscount = this.cas.planDiscount.replace('.', '');
      if (this.cas.planDiscount > 100) {
        this.cas.planDiscount = 100;
      }
    },
    saveCollectionSet() {
      this.$ajax({
        url: '/simulate/saveBaseInfo',
        data: this.cas,
        prompt: true
      }).then(
        this.getSimulateInfo
      );
    },
    getSimulateInfo() {
      this.$ajax({
        url: '/simulate/gotoRobotSimulate',
        method: 'get'
      }).then((res) => {
        const simulateInfo = res.data;
        if (simulateInfo != null) {
          this.cas = simulateInfo;
          this.days = simulateInfo.planDays;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/test_engine/collection_set.vue